/**
 * Created by sung on 2017-02-07.
 */
import {NgModule, Component} from '@angular/core';
import {PanelModule,DataTableModule} from 'primeng/primeng';


@Component({
  selector:'dept-management',
  templateUrl:'./dept_management.html'
})
export class DeptManagementComponent {

}

@NgModule({
  imports:[PanelModule,DataTableModule],
  declarations:[DeptManagementComponent],
  exports:[DeptManagementComponent],
  providers:[]
})
export class DeptManagementModule{

}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/system/dept_management.ts